import { IAccountBillTo } from '../../models/account';
import { IAccount } from '../../models/company-account';
import { IResult } from '../../models/result-models';
import {
    LOAD_BILL_TO_ACCOUNTS_ERROR,
    LOAD_BILL_TO_ACCOUNTS_SUCCESS,
    LOAD_SHIP_TO_ACCOUNTS_ERROR,
    LOAD_SHIP_TO_ACCOUNTS_SUCCESS,
    LOAD_SESSION_ACCOUNT_ERROR,
    LOAD_SESSION_ACCOUNT_SUCCESS,
} from './account-actions';

interface LoadBillToAccountsSuccessAction {
    type: 'LOAD_BILL_TO_ACCOUNTS_SUCCESS';
    result: IResult<IAccountBillTo[]>;
}

interface LoadBillToAccountsErrorAction {
    type: 'LOAD_BILL_TO_ACCOUNTS_ERROR';
    result: any;
}

interface LoadShipToAccountsSuccessAction {
    type: 'LOAD_SHIP_TO_ACCOUNTS_SUCCESS';
    payload: IResult<IAccount[]>;
}

interface LoadShipToAccountsErrorAction {
    type: 'LOAD_SHIP_TO_ACCOUNTS_ERROR';
    payload: Error;
}

interface LoadSessionAccountSuccessAction {
    type: 'LOAD_SESSION_ACCOUNT_SUCCESS';
    payload: IResult<IAccountBillTo>;
}

interface LoadSessionAccountErrorAction {
    type: 'LOAD_SESSION_ACCOUNT_ERROR';
    payload: Error;
}

const initialSate = {
    ok: false,
    data: [],
};

type BillToAccountsKnownAction =
    | LoadBillToAccountsSuccessAction
    | LoadBillToAccountsErrorAction;
export const billToAccountsReducer = (
    state: IResult<IAccountBillTo[]> | null | undefined = null,
    action: BillToAccountsKnownAction
) => {
    switch (action.type) {
        case LOAD_BILL_TO_ACCOUNTS_SUCCESS:
            return action.result;
        case LOAD_BILL_TO_ACCOUNTS_ERROR: {
            const result: IResult<IAccountBillTo[]> = {
                ok: false,
                message: action.result.message,
            };
            return result;
        }
        default:
            return state;
    }
};

type ShipToAccountsKnownAction =
    | LoadShipToAccountsSuccessAction
    | LoadShipToAccountsErrorAction;

export const shipToAccountsReducer = (
    state: IResult<IAccount[]> = initialSate,
    action: ShipToAccountsKnownAction
) => {
    switch (action.type) {
        case LOAD_SHIP_TO_ACCOUNTS_SUCCESS:
            return action.payload;
        case LOAD_SHIP_TO_ACCOUNTS_ERROR: {
            const result: IResult<IAccount[]> = {
                ok: false,
                message: action.payload.message,
            };
            return result;
        }
        default:
            return state;
    }
};

type SessionAccountKnownAction =
    | LoadSessionAccountSuccessAction
    | LoadSessionAccountErrorAction;

export const sessionAccountReducer = (
    state: IResult<IAccountBillTo> | null | undefined = null,
    action: SessionAccountKnownAction
) => {
    switch (action.type) {
        case LOAD_SESSION_ACCOUNT_SUCCESS:
            return action.payload;
        case LOAD_SESSION_ACCOUNT_ERROR:
            // eslint-disable-next-line no-case-declarations
            const result: IResult<IAccountBillTo> = {
                ok: false,
                message: action.payload.message,
            };
            return result;
        default:
            return state;
    }
};
